"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTitleRenderer = exports.WrapperLabel = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _text = require("../../text");
var _react2 = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const WrapperLabel = exports.WrapperLabel = /*#__PURE__*/(0, _base.default)('label', process.env.NODE_ENV === "production" ? {
  target: "e1xlo0xo0"
} : {
  target: "e1xlo0xo0",
  label: "WrapperLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "k66h5e",
  styles: "flex:1;position:relative;display:flex;align-items:center;cursor:pointer"
} : {
  name: "k66h5e",
  styles: "flex:1;position:relative;display:flex;align-items:center;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL19mb3JtL2RldGFpbGVkLWJveC9oZWxwZXJDb21wb25lbnRzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRNEIiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL3N1Ym1vZHVsZXMvX2Zvcm0vZGV0YWlsZWQtYm94L2hlbHBlckNvbXBvbmVudHMudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBUZXh0LCBUZXh0VmFyaWFudCB9IGZyb20gJy4uLy4uL3RleHQnO1xuXG5pbXBvcnQgeyBEZXRhaWxlZEJveFRpdGxlUmVuZGVyZXIgfSBmcm9tICcuL2ludGVyZmFjZXMnO1xuXG5leHBvcnQgY29uc3QgV3JhcHBlckxhYmVsID0gc3R5bGVkKCdsYWJlbCcpKHtcbiAgZmxleDogMSxcbiAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgYWxpZ25JdGVtczogJ2NlbnRlcicsXG4gIGN1cnNvcjogJ3BvaW50ZXInXG59KTtcblxuZXhwb3J0IGNvbnN0IGRlZmF1bHRUaXRsZVJlbmRlcmVyOiBEZXRhaWxlZEJveFRpdGxlUmVuZGVyZXIgPSAoe1xuICB0aXRsZVRleHRcbn0pID0+IDxUZXh0IHZhcmlhbnQ9e1RleHRWYXJpYW50LkJvZHlNRH0+e3RpdGxlVGV4dH08L1RleHQ+O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const defaultTitleRenderer = _ref => {
  let {
    titleText
  } = _ref;
  return (0, _react2.jsx)(_text.Text, {
    variant: _text.TextVariant.BodyMD
  }, titleText);
};
exports.defaultTitleRenderer = defaultTitleRenderer;